import React, { useRef } from 'react';
import HeroSection from '../components/HeroSection';
import WelcomeSection from '../components/WelcomeSection';
import LearningOptions from '../components/LearningOptions';
import StrengthsSection from '../components/StrengthsSection';
import CoursesSection from '../components/CoursesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import StatsSection from '../components/StatsSection';
import CertificationsSection from '../components/CertificationsSection';
import FreeDemoBanner from '../components/FreeDemoBanner';

const Home = () => {
  const coursesHeadingRef = useRef(null);

  const scrollToCourses = () => {
    if (coursesHeadingRef.current) {
      const yOffset = -20; // Optional offset to give some space above the heading
      const y = coursesHeadingRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
      
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  };

  return (
    <>
      <HeroSection />
      <WelcomeSection onExploreClick={scrollToCourses} />
      <StrengthsSection />
      <LearningOptions />
      
      {/* Reference point right before the CoursesSection heading */}
      <div ref={coursesHeadingRef} style={{ position: 'relative', top: '-20px' }}></div>
      
      <CoursesSection />
      <CertificationsSection />
      <FreeDemoBanner />
      <StatsSection />
      <TestimonialsSection />
    </>
  );
};

export default Home;